import { FunctionComponent, memo, useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DetailsModalContext } from '../../../../context';
import { NotificationMention } from '../../../../services';
import { getStoryCardName, layoutPath, truncateString } from '../../../utils';
import { NotificationWrapper } from '../NotificationWrapper';
import { MentionContent } from './MentionContent';

interface MentionProps {
  notification: NotificationMention;
  setIsOpen: (isOpen: boolean) => void;
  logOpen: (notification_id: number) => void;
}

export const Mention: FunctionComponent<MentionProps> = memo(
  ({ notification, setIsOpen, logOpen }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const { setDetailsModalData } = useContext(DetailsModalContext);

    const { id, deliveredTime, author, story, storyCard } = notification;

    const onClickHandler = () => {
      if (story && storyCard) {
        const { id: storyId } = story;
        const { id: cardId } = storyCard;

        isMobileOnly
          ? navigate(layoutPath(`/details/${storyId}/${cardId}`))
          : setDetailsModalData({ storyId, cardId });

        logOpen(id);
      }

      setIsOpen(false);
    };

    if (!storyCard) {
      return null;
    }

    const { id: userId, avatar, screenName } = author;

    const { category } = storyCard;

    const title = truncateString({
      value: category ? category.name : getStoryCardName({ card: storyCard, t }),
      maxLength: 100,
    });

    return (
      <NotificationWrapper
        key={id}
        userId={userId}
        avatarUrl={avatar?.url}
        deliveredTime={deliveredTime}
        onClick={onClickHandler}
        hasLink
      >
        <MentionContent authorName={screenName} title={title} />
      </NotificationWrapper>
    );
  }
);
